var _title, _desc, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVacuumCleaner = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "siurblys")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzsakymai",
    transform: "translate(-1353.000000, -176.000000)",
    fill: "#464648",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "siurblys",
    transform: "translate(1353.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.430114,16.499925 C14.430114,14.84325 13.1443454,13.5 11.5583488,13.5 L8.68658361,13.5 L4.46275826,0.262034402 C4.41295784,0.105954045 4.2679345,-1.41117884e-16 4.10410179,0 L0.448189338,0 C0.240270374,3.81940942e-17 0.07171875,0.168551624 0.07171875,0.376470588 L0.07171875,1.12337941 C0.07171875,1.33129838 0.240270374,1.49985 0.448189338,1.49985 L3.06943892,1.49985 C3.2332801,1.49985 3.37830889,1.60581481 3.42810236,1.76190626 L7.77814611,15.398325 L7.25113176,16.499925 L7.25113176,17.6235294 C7.25113176,17.8314484 7.41968338,18 7.62760234,18 L15.4897414,18 C15.6976604,18 15.866212,17.8314484 15.866212,17.6235294 L15.866212,16.8763956 C15.866212,16.6684766 15.6976604,16.499925 15.4897414,16.499925 L14.430114,16.499925 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99648525,11.9997 L11.4376085,11.9997 C11.6455275,11.9997 11.8140791,11.8311484 11.8140791,11.6232294 C11.8140791,11.5843908 11.8080692,11.5457862 11.7962626,11.5087856 L9.98936655,5.846175 C9.53837838,4.431825 8.19165963,3.2607 6.86389358,3.0447 L9.63783211,11.737676 C9.68763584,11.8937511 9.83265658,11.9997 9.99648525,11.9997 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVacuumCleaner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vacuum-cleaner.2ebb53ed.svg";
export { ForwardRef as ReactComponent };